import { render, staticRenderFns } from "./EmptyLayout.vue?vue&type=template&id=3b3c8c7b&"
import script from "./EmptyLayout.vue?vue&type=script&lang=ts&"
export * from "./EmptyLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports